export default "__VITE_ASSET__BxGH3ihS__"